import { MenuOutlined } from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React, { useEffect, useRef } from "react";

/* eslint-disable @typescript-eslint/naming-convention */
interface RowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  "data-row-key": string;
}
/* eslint-enable @typescript-eslint/naming-convention */

const TableRow = ({ children, ...props }: RowProps): JSX.Element => {
  const rowRef = useRef<HTMLTableRowElement | null>(null);

  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props["data-row-key"],
  });

  const computedTransform = CSS.Transform.toString(
    transform && { ...transform, scaleY: 1 },
  );

  useEffect(() => {
    const node = rowRef.current;
    if (node) {
      node.style.setProperty("--row-transform", computedTransform ?? null);
      node.style.setProperty("--row-transition", transition ?? null);

      node.classList.add("transform-custom", "transition-custom");
      if (isDragging) {
        node.classList.add("dragging");
      } else {
        node.classList.remove("dragging");
      }
    }
  }, [transform, transition, isDragging]);

  return (
    <tr
      ref={(node) => {
        rowRef.current = node;
        setNodeRef(node);
      }}
      className=""
      {...props}
      {...attributes}
    >
      {React.Children.map(children, (child) => {
        if ((child as React.ReactElement).key === "sort") {
          return React.cloneElement(child as React.ReactElement, {
            children: (
              <MenuOutlined
                ref={setActivatorNodeRef}
                className="menu-icon"
                {...listeners}
              />
            ),
          });
        }
        return child;
      })}
    </tr>
  );
};

export default TableRow;
